import { isRoutinePrefixedId } from "@/utils/hyperlink";
import { in_electron } from "@/utils/in";

const openExternal = in_electron
  ? require("electron").shell.openExternal
  : globalThis.open;

/**
 * Open a URL in the OS (Electron) or a new tab (web).
 *
 * Routine record ids (`automation:…`, `object:…`, …) are valid URIs, but
 * no OS handler is registered for those schemes. Refuse them here so a
 * missed in-app route cannot produce macOS's "no application set to open
 * the URL" dialog.
 */
export const open = (url: string) => {
  if (isRoutinePrefixedId(url)) {
    return Promise.reject(
      new Error(`Refusing to hand Routine id to the OS: ${url}`)
    );
  }
  return openExternal(url);
};
